import React, { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import { useResume } from '../context/ResumeContext';
import DraftEditor from './common/DraftEditor';
import { ADDITONAL_PREDEFINE_SECTIONS, MONTHS } from '../constants/constants';
import DeleteIcon from '../assets/images-new/icons/bin-icon.svg';
import { usePopup } from '../context/PopupContext';
import { formatDate, rbDate2String, removeBodyScroll } from '../helper';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import DraggableIcon from '../assets/images/draggable-icon.svg';
const Accomplishments = (props) => {
  const {
    resume: {
      heading: { fname },
      accomplishments,
      enabled_tabs
    },
    handlers: {
      updateResumePreview,
    },
  } = useResume();
  const confirmbox = usePopup();
  let grid = accomplishments.hasOwnProperty('grid') ? accomplishments.grid : {};
  const emptyrow = ADDITONAL_PREDEFINE_SECTIONS.accomplishments.struct.grid.row_1
  const [checkField, setCheckField] = useState('');
  useEffect(() => {
    if (!accomplishments.hasOwnProperty('grid')) {
      let struct = { ...emptyrow };
      struct.content = accomplishments.content;
      updateResumePreview({ accomplishments: { ...accomplishments, grid: { row_1: { ...struct } } } });
    }

  }, []);

  const updateRow = (input, id) => {
    const row = {
      [id]: {//example certifications_1
        ...grid[id],
        ...input
      }
    }
    updateResumePreview(
      { accomplishments: { ...accomplishments, grid: { ...grid, ...row } }, current_tab: 'additional_sections',  }
    )
  }
  const addRow = (newname = '') => {
    const id = 'row_' + Math.floor(Math.random() * 1000)
    const row = { ...emptyrow }
    /**
     * START
     * Changes to close automatically the previously opened tabs on adding a new one
     * Ticket: https://gitlab.dailyrssmail.com/growthlabs/resumebuilder-app/-/issues/530
     * Date: 2024-01-05
     */
    grid = Object.keys(grid).map(key => {
      return {...grid[key], open: false}
    })
    /**
     * END
     */
    updateResumePreview(
      { accomplishments: { ...accomplishments, grid: { ...grid, [id]: { ...row } } }, current_tab: 'additional_sections',  }
    )
  }
  const deleteRow = (id) => {
    if (grid.hasOwnProperty(id)) {
      let t = { ...grid }
      delete t[id]
      if (!Object.keys(t).length) {//Last need to handle with default settings
        const newid = 'row_' + Math.floor(Math.random() * 1000)
        t = { [newid]: { ...emptyrow } }
      }
      updateResumePreview({ accomplishments: { ...accomplishments, grid: { ...t } }, current_tab: 'additional_sections' })
    }
  }

  const fieldFocus = (e, id) => {
    setCheckField(e.target.name + '-' + id)
  }
  const fieldBlur = (e, id) => {
    setCheckField('');
  }

  const TabStatus = props => <div className="arrow-action" onClick={props.onClick}> {props.t ? <i className="icon-chevron-left"></i> : <i className="icon-right-arrow"></i>}</div>;
  
  const onDragEnd = result => {
    const { destination, source, draggableId } = result;
    if (!destination) return
    if (destination.droppableId === source.droppableId && destination.index === source.index) return
    const grid1 = {};
    let ids = Object.keys(accomplishments.grid), grid = {};
    ids.splice(source.index, 1)
    ids.splice(destination.index, 0, draggableId)
    ids.forEach(element => {
      const id = 'row_' + Math.floor(Math.random() * 1000)
      grid1[id] = { ...accomplishments.grid[element] }
      //grid1.push( { ...section.grid[element] })
      })
    updateResumePreview(
      { 
        accomplishments: { 
          ...accomplishments, 
          grid: {...grid1},
        }, current_tab: 'additional_sections',  }
    )    
}
  return (<DragDropContext onDragEnd={onDragEnd}>
  <div className="editor-form accomplishments-blocks">
  <Droppable droppableId={'unrelavent'}>
    {(provided) => (
    <div 
      ref={provided.innerRef} 
      {...provided.droppableProps}
      >
        {Object.keys(grid).map((id,index) => (
          <Draggable draggableId={id} index={index} key={id}>
          {(provided, snapshot) => (
          <div className="sub-list-wrap" key={id} ref={provided.innerRef} {...provided.draggableProps}>
            <div className="sub-list" onClick={() => (updateRow({ open: !grid[id].open }, id))}>
              <div className='addtiaonl-section-reorder'>
              <div className="reorder">
                  <div type="button" className="btn btn-link" dataid={id} {...provided.dragHandleProps}><DraggableIcon /></div>
              </div>
              <span className="sub-name">{grid[id].award_name.length ? grid[id].award_name : 'Award Name'}</span>
              </div>
              <div className="controls">
                <div className="delete-action">
                  <span onClick={(e) => {confirmbox.show('row_delete', null, () => deleteRow(id)), removeBodyScroll(true)}}>
                    <DeleteIcon />
                  </span>
                </div>
                <TabStatus t={grid[id].open} onClick={() => (updateRow({ open: !grid[id].open }, id))} />
              </div>
            </div>
            {grid[id].open && <div className="sub-form">
              <div className="form-row">
                <div className="field-wrap">
                  {/* <label htmlFor="award_name" className={`label${checkField == 'award_name-' + id ? ' label-focus' : ''}`}>Award Name</label> */}
                  <input
                    placeholder="Award Name"
                    type="text"
                    name="award_name"
                    value={grid[id].award_name}
                    onChange={(e) => {
                      updateRow({ award_name: e.target.value }, id)
                    }}
                    onFocus={(e) => fieldFocus(e, id)}
                    onBlur={(e) => fieldBlur(e, id)}
                  />
                </div>
              </div>
              <div className="form-row column-2">
                <div className="field-wrap">
                  {/* <label htmlFor="awarded_by" className={`label${checkField == 'awarded_by-' + id ? ' label-focus' : ''}`}>Awarded By</label> */}
                  <input
                    placeholder="Awarded By"
                    type="text"
                    name="awarded_by"
                    onChange={(e) => {
                      updateRow({ awarded_by: e.target.value }, id)
                      //e.target.value
                    }}
                    onFocus={(e) => fieldFocus(e, id)}
                    onBlur={(e) => fieldBlur(e, id)}
                    value={grid[id].awarded_by}
                  />
                </div>
                <div className="field-wrap date-field">
                  {/* <label htmlFor="awarded_date" className={`label${checkField == 'awarded_date-' + id ? ' label-focus' : ''}`}>Awarded Date</label> */}
                  <DatePicker
                    showMonthYearPicker
                    //value={}
                    placeholderText="Awarded Date"
                    value={formatDate(grid[id].awarded_date)}
                    selected={formatDate(grid[id].awarded_date)}
                    name="awarded_date"
                    className="form-input borderaccent custom-date-picker"
                    dateFormat="MMMM yyyy"
                    disabled={false}
                    autoComplete="off"
                    onChange={e => updateRow({ awarded_date: rbDate2String(e.getMonth(), e.getFullYear()) }, id)}
                    onChangeRaw={e => e.preventDefault()}
                    onFocus={(e) => fieldFocus(e, id)}
                    onBlur={(e) => fieldBlur(e, id)}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="field-wrap">
                  <label htmlFor="description" className="label editor-label">Summary</label>
                  <DraftEditor
                    name="description"
                    // placeholder="e.g. Passionate science teacher with 8+ years of experience and a track record of..."
                    className="validate"
                    value={grid[id].content}
                    onInputChange={val => updateRow({ content: val }, id)}
                  />
                </div>
              </div>
            </div>}
        </div>
         )}
        </Draggable>
      ))}
       {provided.placeholder}
    </div>
    )}
     </Droppable>
    <div className="add-more-wrap">
      <span
        className="add-more-skills"
        onClick={(e) => {
          addRow()
        }}>
        <i className="icon-plus-icon"></i> Add one more
      </span>
    </div>
  </div></DragDropContext>);
}

export default Accomplishments;